
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 2227","fill":"none"}},[_c('path',{attrs:{"data-name":"사각형 1370","d":"M34 34H0V0h34z"}}),_c('g',{attrs:{"data-name":"Icon feather-arrow-left","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"패스 61","d":"M10.997 17.001h12"}}),_c('path',{attrs:{"data-name":"패스 62","d":"M16.649 10.999l6.348 6-6.348 6"}})])])])
          )
        }
      }
    